import React, { Suspense } from "react";
import "./App.css";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { Spin } from "antd";
import LoadingComponent from "components/LoadingComponent";

const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));
const Login = React.lazy(() => import("./containers/Login"));

function App() {
  return (
    <Suspense fallback={<LoadingComponent inline={true} />}>
      <BrowserRouter>
        <Switch>
          <Redirect exact from="/" to="/login" />
          <Route exact path="/login" component={Login} />
          <Route path="/:locale" component={DefaultLayout} />
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
